<template>
  <div>
    <delete-campaign
      v-if="showDelete"
      :title="'Delete global campaign?'"
      @closed="showDelete = false"
      @confirmed="deleteConfirmed()"
    />
    <delete-banner
      v-if="showBannerDelete"
      :title="'Delete this banner from global campaign?'"
      @closed="showBannerDelete = false"
      @confirmed="deleteBannerConfirmed()"
    />
    <v-alert
      v-if="!permissionCheck('read-global-campaigns')"
      text
      prominent
      type="warning"
      color="red"
      border="left"
      class="authorization-alert"
    >
      You are not authorized to perform this action. Please contact your administrator.
    </v-alert>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-row>
        <v-col>
          <v-toolbar
            flat
            color="#ECEFF1"
          >
            <v-toolbar-title class="my-toolbar-style">
              Global Campaign List
            </v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="globalCampaignTable.headers"
            :items="globalCampaignList"
            :single-expand="singleExpand"
            :search="search"
            :expanded.sync="expanded"
            item-key="id"
            show-expand
            class="elevation-1 clickable"
            mobile-breakpoint="100"
          >
            <template v-slot:item="{ item, expand, isExpanded }">
              <tr
                class="clickable"
                @click="getCampaignContent(item.id)"
              >
                <td>{{ item.name }}</td>
                <td>{{ item.start | convertStringToLocalDatetime }}</td>
                <td>
                  <font v-if="item.end">
                    {{ item.end | convertStringToLocalDatetime }}
                  </font>
                  <font v-else>
                    No End date
                  </font>
                </td>
                <td>
                  <font
                    :color="getColor(item.active)"
                    class="font-my-style"
                  >
                    {{ item.active | statusUpdate }}
                  </font>
                </td>
                <td>
                  {{ item.updated_at | diffHumans }}
                </td>
                <td>
                  <v-btn
                    class="mt-n2"
                    elevation="1"
                    fab
                    color="#37474F"
                    x-small
                    icon
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-col>
                    <v-btn
                      class="mt-n2"
                      elevation="1"
                      fab
                      x-small
                      icon
                      color="#C62828"
                      @click.stop
                      @click="deleteGlobalCampaign(item.id, item.banners)"
                    >
                      <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                  </v-col>
                </td>
                <td>
                  <v-btn
                    icon
                    small
                    @click.stop
                    @click="expand(!isExpanded)"
                  >
                    <v-icon
                      v-if="!isExpanded"
                      @click="getBoardDetails(item.banners)"
                    >
                      mdi-arrow-down-drop-circle
                    </v-icon>
                    <v-icon v-if="isExpanded">
                      mdi-arrow-up-drop-circle
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td
                v-if="permissionCheck('read-campaign')"
                :colspan="headers.length"
              >
                <v-row>
                  <v-col
                    v-if="showAdvancedSchedule(item.schedules)"
                    cols="12"
                    lg="4"
                  >
                    <v-card>
                      <v-toolbar
                        color="#37474F"
                        dark
                      >
                        <v-toolbar-title>Advanced Schedule</v-toolbar-title>
                      </v-toolbar>
                      <v-list>
                        <v-list-item-group>
                          <template v-for="(schedule, index) in item.schedules">
                            <v-list-item :key="'item'+ index">
                              <template>
                                <v-list-item-content class="ml-1">
                                  <v-list-item-title>
                                    <strong>
                                      Start: {{ schedule.start | twelveHour }} End: {{ schedule.end | twelveHour }}
                                    </strong>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    <strong>
                                      Active Days: {{ schedule.active_days | arrangePretty }}
                                    </strong>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                            <v-divider
                              v-if="index < globalCampaignList.length - 1"
                              :key="index"
                            />
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    :lg="isLargeScreen"
                  >
                    <v-card>
                      <v-toolbar
                        color="#37474F"
                        dark
                      >
                        <v-toolbar-title>
                          File Preview
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text class="text-body-1 text-center">
                        <v-row class="my-row-style">
                          <v-col
                            v-for="banner in item.banners"
                            :key="banner.id"
                            :cols="filePreviewDispay"
                          >
                            <v-badge
                              right
                              overlap
                            >
                              <v-icon
                                slot="badge"
                                small
                                @click.native="deleteFile(item.id, banner.id, item.banners.length, banner.digi_board_time_slots)"
                              >
                                mdi-trash-can-outline
                              </v-icon>
                              <div v-if="isContentImgOrGif(banner.content.content_type)">
                                <v-img
                                  width="75"
                                  height="75"
                                  contain
                                  class="my-media-file"
                                  :src="getFilePath(banner.content.file_path)"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height ma-0"
                                      align="center"
                                      justify="center"
                                    >
                                      <v-progress-circular
                                        indeterminate
                                        color="#FF3700"
                                      />
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>
                              <div v-else>
                                <video
                                  width="75"
                                  height="75"
                                  controls
                                  class="my-media-file"
                                  contain
                                >
                                  <source
                                    :src="getFilePath(banner.content.file_path)"
                                    type="video/mp4"
                                  >
                                </video>
                              </div>
                            </v-badge>
                            <div
                              v-for="(board, index) in banner.digi_board_time_slots"
                              :key="index"
                            >
                              {{ board.digi_board.external_id }} - {{ board.time_slot.duration }}Sec
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="4"
                  >
                    <v-card>
                      <v-toolbar
                        color="#37474F"
                        dark
                      >
                        <v-toolbar-title>Device Details</v-toolbar-title>
                      </v-toolbar>
                      <v-list>
                        <v-list-item-group>
                          <template v-for="(device, index) in boardDetails ">
                            <v-list-item :key="'item'+ index">
                              <template>
                                <v-list-item-content class="ml-1">
                                  <v-list-item-title>
                                    <strong>
                                      Device Id: {{ device.external_id }}
                                    </strong>
                                  </v-list-item-title>
                                  <br>
                                  <v-list-item-subtitle>
                                    <strong>
                                      Device Location: {{ device.location }}
                                    </strong>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                            <v-divider
                              v-if="index < boardDetails.length - 1"
                              :key="index"
                            />
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <div class="py-3" />
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </div>
</template>

<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';
  import { cdnUrl } from 'src/app-globals';
  import Constants from 'src/constants';
  import ModuleHelper from 'src/helpers/module-helper';
  import global from 'src/mixins/global';

  export default {
    name: 'GlobalCampaignList',
    components: {
      'centre-spinner': spinner,
      'delete-campaign': DeleteDialog,
      'delete-banner': DeleteDialog,
    },
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
      arrangePretty (val) {
        return val.join(', ');
      },
      twelveHour (val) {
        return moment(val, 'HH:mm').format('hh:mm a');
      },
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (active) {
        if (active === true) return 'Active*';
        else return 'Inactive';
      },
    },
    mixins: [global],
    data () {
      return {
        loading: false,
        search: '',
        showDelete: false,
        showBannerDelete: false,
        deleteId: '',
        deleteBannerId: '',
        deleteCampaignId: '',
        globalCampaignTable: {
          headers: [
            { text: 'Name', align: 'start', value: 'name' },
            { text: 'Start', value: 'start' },
            { text: 'End', value: 'end' },
            { text: 'Status', value: 'active' },
            { text: 'Last Updated', value: 'updated_at' },
            { text: 'Edit', value: 'edit' },
            { text: 'Delete', value: 'delete' },
            { text: 'More', value: 'data-table-expand' },
          ],
        },
        expanded: [],
        singleExpand: true,
        helper: new ModuleHelper(),
        boardExternalIds: [],
        boardDetails: [],
      };
    },
    computed: {
      globalCampaignList () {
        const list = this.$store.getters['campaigns/getGlobalCampaignList'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.updated_at) - new Date(a.updated_at);
        });
        return sortedList;
      },
      digiBoards () {
        return this.$store.getters['digiboards/getDigiBoards'];
      },
      isLargeScreen () {
        if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return 4;
        } else {
          return 12;
        }
      },
      filePreviewDispay () {
        if (this.isLargeScreen === 4) {
          return 4;
        } else {
          return 2;
        }
      },
    },
    mounted () {
      this.permissionCheck('read-global-campaigns') && this.getGlobalCampaignList();
      (this.permissionCheck('read-global-campaigns') && this.permissionCheck('read-campaign')) && this.fetchDigiBoards();
    },
    methods: {
       showAdvancedSchedule (schedule) {
        if (this.helper.isSubModuleExist(Constants.MODULE_CAMPAIGN, Constants.SUB_MODULE_ADVANCED_SCHEDULING) && schedule.length > 0) {
          return true;
        }
        return false;
      },
      async getGlobalCampaignList () {
        this.loading = true;
        await this.$store.dispatch('campaigns/fetchGlobalCampaignList');
        this.loading = false;
      },
      fetchDigiBoards () {
        this.$store.dispatch('digiboards/fetchDigiBoards');
      },
      getColor (active) {
        if (active === false) return '#C62828';
        else return '#2E7D32';
      },
      deleteGlobalCampaign (globalCampaignId, contents) {
        if (this.permissionCheck('remove-campaign') === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to perform this action. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        for (const content of contents) {
          for (const slot of content.digi_board_time_slots) {
            const isFound = this.boardExternalIds.includes(slot.digi_board.external_id);
            if (!isFound) {
              this.boardExternalIds.push(slot.digi_board.external_id);
            }
          }
        }
        this.showDelete = true;
        this.deleteId = globalCampaignId;
      },
      deleteConfirmed () {
        this.$store.dispatch('publish/addSelectedBoardsForPublish', this.boardExternalIds);
        this.$store.dispatch('campaigns/deleteCampaign', this.deleteId)
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Global campaign deleted.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.getGlobalCampaignList();
            this.$store.dispatch('campaigns/fetchUserCampaignList');
          }).finally(
            this.showDelete = false,
            this.deleteId = null,
          );
      },
      getFilePath (fileName) {
        return `${cdnUrl}/${fileName}`;
      },
      deleteFile (campaignId, bannerId, bannerLength, boards) {
        if (this.permissionCheck('remove-campaign-by-bannerId') === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to perform this action. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        if (bannerLength === 1) {
          this.$store.dispatch('alert/onAlert', {
            message: 'At least one content is required to run the campaign.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        const digiBoardExternalIds = boards.map(item => item.digi_board.external_id);
        this.showBannerDelete = true;
        this.deleteBannerId = bannerId;
        this.deleteCampaignId = campaignId;
        this.boardExternalIds = digiBoardExternalIds;
      },
      deleteBannerConfirmed () {
        this.$store.dispatch('publish/addSelectedBoardsForPublish', this.boardExternalIds);
         this.$store.dispatch('campaigns/removeBannerFromCampaign', {
          campaignId: this.deleteCampaignId,
          bannerId: this.deleteBannerId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Banner removed from campaign.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$store.dispatch('campaigns/fetchUserCampaignList');
          this.getGlobalCampaignList();
        }).finally(
          this.showBannerDelete = false,
          this.campaignId = null,
          this.bannerId = null,
        );
      },
      getCampaignContent (campaignId) {
        if (this.permissionCheck('edit-campaign') === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to perform this action. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        this.$router.push(`/campaign/${campaignId}`);
      },
      isContentImgOrGif (contentType) {
        if (contentType === 'image' || contentType === 'gif') {
          return true;
        }
        return false;
      },
      getBoardDetails (contents) {
        this.boardDetails = [];
        if (this.permissionCheck('read-campaign') === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to perform this action. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        for (const content of contents) {
          for (const slot of content.digi_board_time_slots) {
            const isFound = this.boardDetails.some(item => item.external_id === slot.digi_board.external_id);
            if (!isFound) {
              this.boardDetails.push({
                external_id: slot.digi_board.external_id,
                location: slot.digi_board.location,
              });
            }
          }
        }
      },
    },
  };
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table {
  background-color: #ECEFF1;
}
.my-toolbar-style {
  color: #37474F;
  font-weight: bold;
}
.authorization-alert {
  font-family: 'Times New Roman', Times, serif;
  font-size: 16px;
}
.my-media-file {
  background-color: rgb(236, 239, 241);
}
.my-card-size {
  height: 120px;
  padding-left: 5px;
  padding-right: 5px;
}
.my-row-style {
  margin-top: 5px;
}
</style>
